import { Table } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { ConsultaUsuarios } from '../../models';
import { UsuarioTableColumns } from '../../models/UsuariosTable';
import { UserStore } from '../../stores';

interface TablaUsuariosProps {
    userStore?: UserStore;
}

@inject('userStore')
@observer
class TablaUsuarios extends React.Component<TablaUsuariosProps> {
    onRow = (record: ConsultaUsuarios, index: number) => ({
        onClick: () => this.handleFila(record)
    });

    handleFila = async (record: ConsultaUsuarios) => {
        const { userStore } = this.props;
        userStore!.tipoModal = 'Consulta';
        userStore!.openModal = true;
        userStore!.idUsuariConsulta = record.id;
        await userStore!.getUsuarioConsulta();

        // const { userStore } = this.props;
        // if (userStore!.rol != 'ROL-JADP') {
        //     const response = await this.props.userStore!.getResponsiva(record.id);
        //     if (!response) {
        //         return;
        //     }

        //     const type = 'application/pdf';
        //     const blob = new Blob([response!.data], { type });
        //     const url = window.URL.createObjectURL(blob);
        //     const link = document.createElement('a');
        //     link.download = record!.usuarioAcceso;
        //     link.href = url;
        //     link.click();
        //     const newWindow = window.open('/');
        //     newWindow!.onload = () => {
        //         newWindow!.location.replace(url);
        //     };
        //     const fileDownload = require('react-file-download');
        //     fileDownload(blob, record!.usuarioAcceso + '.pdf');
        // }
    };

    render() {
        const { userStore } = this.props;
        return (
            <>
                <Table 
                    columns={UsuarioTableColumns}
                    dataSource={userStore!.listaUsuarios}
                    rowKey="id"
                    onRow={this.onRow}
                    pagination={{ pageSize: 8 }}
                    bordered={true}
                    loading={userStore!.isFetching}
                />
            </>
        );
    }
}
export default TablaUsuarios;
